// Copyright (C) 2019 TANNER AG

import React, { useState } from "react";
import { compose } from "recompose";
import * as PropTypes from "prop-types";
import Header from "./header";
import { withRouter } from "react-router-dom";
import PurchasePrice from "./modules/purchaseprice";
import ResidualValue from "./modules/residualvalue";
import DrivingProfile from "./modules/drivingprofile";
import EfficientHybrid from "./modules/efficienthybrid";
import HoldingPeriod from "./modules/holdingperiod";
import AnnualMileage from "./modules/annualmileage";
import FuelPrice from "./modules/fuelprice";
import { withStore } from "../store/withstore";
import { TileButton } from "../components/button";
import { Module } from "./module";
import { findIndex, propEq } from "ramda";
import { TcoLccImage } from "../components/tcolccimage";
import { Zoom } from "@material-ui/core";
import DefaultParameterTable from "../defaultparamters/table"

const getModules = () => ([
	{
		id: "drivingProfile",
		component: DrivingProfile
	},
	{
		id: "efficientHybrid",
		component: EfficientHybrid
	},
	{
		id: "fuelPrice",
		component: FuelPrice
	},
	{
		id: "holdingPeriod",
		component: HoldingPeriod
	},
	{
		id: "annualMileage",
		component: AnnualMileage
	},
	{
		id: "purchasePrice",
		component: PurchasePrice
	},
	{
		id: "residualValue",
		component: ResidualValue
	}
]) ;

const removeModule = (id, modules) => {
	const index = findIndex(propEq("id", id))(modules);
	if (index !== -1) {
		modules.splice(index, 1);
	}
};

export let ModuleConfiguration = (props) => {
	const { store: { a, b, configuration }, history } = props;
	const modules = getModules();

	if (!a.bus.id || !b.bus.id) {
		history.push("/tco-lcc");
	}

	// For LCC calculation - purchase price and residual value not necessary
	if (configuration === "LCC") {
		removeModule("purchasePrice", modules);
		removeModule("residualValue", modules);
	}

	const [activeModule, setActiveModule] = useState(modules[0].id);
	const activeIndex = findIndex(propEq("id", activeModule))(modules);

	return (
		<React.Fragment>
			<Header backRoute="/tco-lcc/type" progress={(activeIndex + 1) / modules.length * 100}/>
			<div style={{ margin: "120px 0", width: "100%" }}>
				{modules.map(({ id, component: Component }, index) => (
					<Component
						key={id}
						id={id}
						nextId={modules[index + 1] && modules[index + 1].id}
						activeModule={activeModule}
						setActiveModule={setActiveModule}
						final={Boolean(index + 1 === modules.length)}
					/>
				))}
			</div>
		</React.Fragment>
	);
};

ModuleConfiguration.propTypes = {
	store: PropTypes.object
};

ModuleConfiguration = compose(
	withStore,
	withRouter
)(ModuleConfiguration);

export let TypeConfiguration = ({ store, storeAction, history }) => {
	const { a, b, configuration } = store;
	const [value, setValue] = useState(configuration);

	if (!a.bus.id || !b.bus.id) {
		history.push("/tco-lcc");
	}

	const onContinue = () => {
		storeAction.setConfiguration(value);
		history.push("/tco-lcc/configuration");
	};

	return (
		<React.Fragment>
			<Header backRoute="/tco-lcc/defaultparameters"/>
			<div style={{ margin: "120px 0", width: "100%" }}>
				<Module
					id="type"
					activeModule="type"
					label=""
					title="calculator.type.query"
					onContinue={onContinue}
					continueEnabled={Boolean(value)}
					queryA={(
						<div>
							<div style={{
								display: "flex",
								flexDirection: "row",
								justifyContent: "center"
							}}>
								<TileButton
									onClick={() => setValue("TCO")}
									active={value === "TCO"}
								>
									TCO
								</TileButton>
								<TileButton
									onClick={() => setValue("LCC")}
									active={value === "LCC"}
								>
									LCC
								</TileButton>
							</div>
							<Zoom in={value} timeout={600}>
								<TcoLccImage
									type={value}
									style={{
										paddingTop: "1.5rem",
										marginBottom: "-1rem",
										maxWidth: "400px"
									}}
								/>
							</Zoom>
						</div>
					)}
				/>
			</div>
		</React.Fragment>
	);
};

TypeConfiguration = compose(
	withStore,
	withRouter
)(TypeConfiguration);

export let DefaultParameterConfiguration = ({ store, storeAction, history }) => {
	const { a, b } = store;

	if (!a.bus.id || !b.bus.id) {
		history.push("/tco-lcc");
	}

	const onContinue = () => {
		history.push("/tco-lcc/type");
	};

	return (
		<React.Fragment>
			<Header backRoute="/tco-lcc"/>
			<div style={{ margin: "120px 0 0", width: "100%" }}>
				<Module
					id="parameter"
					activeModule="parameter"
					label=""
					title="default.parameter.entry.title"
					onContinue={onContinue}
					continueEnabled
					queryA={(
						<div>
							<DefaultParameterTable/>
						</div>
					)}
				/>
			</div>
		</React.Fragment>
	);
};

DefaultParameterConfiguration = compose(
	withStore,
	withRouter
)(DefaultParameterConfiguration);



// WEBPACK FOOTER //
// ./src/tco/configuration/index.js